import { useQuery } from '@tanstack/react-query';
import { ExamGenApi } from '../client';

/** Next national exam forecast; polls while past questions are still being tagged. */
export function usePrediction(neId: number | null, subjectId: number | null, total: number) {
  return useQuery({
    queryKey: ['exam_gen', 'prediction', neId, subjectId, total],
    queryFn: () => ExamGenApi.predictNextExam(neId!, subjectId!, total),
    enabled: !!neId && !!subjectId,
    staleTime: 60_000,
    refetchInterval: (q) => (q.state.data?.tagging?.running ? 8000 : false),
  });
}
